import styled from "styled-components";

export const TaxRatesWrapper = styled.div`
  .headerContainer {
    justify-content: center !important;
  }
  .btn:hover {
    color: #fff;
  }
  .translation {
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  //------table------
  .edit-background {
    background-color: transparent !important;
  }
  .table {
    margin-top: 35px;
    min-width: 1000px;
    width: 100%;
  }
  .tableHead {
    border-radius: 0px !important;
    border-left: none;
    border-right: none;
  }
  .tableHead tr {
    border: none;
  }
  tbody tr {
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  tbody .table-row:first-child {
    margin-top: 0;
  }
  td,
  th {
    text-align: center;
    padding: 15px 5px;
    word-break: break-word;
  }
  .status {
    height: 18px;
    width: 18px;
  }
  .action button {
    background: white;
    border: none;
    cursor: pointer;
  }
  .clipboard{
    width:200px !important;
  }
  .clipboard img{
    cursor:pointer;
  }
  .copyText{
    border: 1px solid black;
    padding:2px 5px;
    border-radius:5px;
    display: inline-block;
    width: 120px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
  .percentage{
    font-size:12px;
    font-style:italic;
    font-weight: 100;
  }
`;
